import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BuildIcon from '@mui/icons-material/Build';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import Groups2Icon from '@mui/icons-material/Groups2';
import HistoryIcon from '@mui/icons-material/History';
import InsightsIcon from '@mui/icons-material/Insights';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import { matchPath } from 'react-router-dom';
import { hasRequiredRole, INTERNAL_ROUTE_ROLES, normalizeRole } from '../auth/authorization';

export const drawerWidth = 280;
export const collapsedDrawerWidth = 88;

export const adminNavSections = [
  {
    title: 'Home',
    items: [
      {
        label: 'My Dashboard',
        path: '/me',
        icon: AccountCircleIcon,
        allowedRoles: INTERNAL_ROUTE_ROLES.staff,
        matchers: ['/me'],
      },
    ],
  },
  {
    title: 'Work',
    items: [
      {
        label: 'AAR Hub',
        path: '/me/aars',
        icon: ListAltIcon,
        allowedRoles: INTERNAL_ROUTE_ROLES.staff,
        matchers: [
          '/me/aars',
          '/me/aars/new',
          '/me/aars/photos',
          '/me/aars/historical-review',
          '/me/aars/historical-review/:rowId',
          '/me/aars/event/:eventId',
          '/me/aars/:aarId',
          '/me/aars/:aarId/edit',
          '/me/aars/:aarId/photos',
        ],
      },
      {
        label: 'Volunteer Network',
        path: '/admin/volunteers',
        icon: VolunteerActivismIcon,
        allowedRoles: INTERNAL_ROUTE_ROLES.staff,
        matchers: [
          '/admin/volunteers',
          '/admin/volunteers/new',
          '/admin/volunteers/:volunteerId',
          '/admin/volunteers/:volunteerId/edit',
        ],
      },
      {
        label: 'vAT Field Pulse',
        path: '/admin/vat-pulse/new',
        icon: RecordVoiceOverIcon,
        allowedRoles: INTERNAL_ROUTE_ROLES.staff,
        matchers: ['/admin/vat-pulse/new'],
      },
      {
        label: 'ALUM',
        path: '/admin/alum',
        icon: Groups2Icon,
        allowedRoles: INTERNAL_ROUTE_ROLES.reporting,
        matchers: ['/admin/alum', '/admin/alum/new', '/admin/alum/:alumId', '/admin/alum/:alumId/edit'],
      },
      {
        label: 'Event Pages',
        path: '/admin/events',
        icon: CalendarMonthIcon,
        allowedRoles: INTERNAL_ROUTE_ROLES.adminContent,
        matchers: [
          '/admin/events',
          '/admin/events/new',
          '/admin/events/:id/edit',
          '/admin/events/*',
        ],
      },
      { label: 'RSVP Operations', path: '/admin/rsvps', icon: BuildIcon, allowedRoles: INTERNAL_ROUTE_ROLES.adminRsvps },
      { label: 'Check-in', path: '/admin/checkin', icon: TaskAltIcon, allowedRoles: INTERNAL_ROUTE_ROLES.adminCheckin },
      { label: 'Media Library', path: '/admin/media', icon: PermMediaIcon, allowedRoles: INTERNAL_ROUTE_ROLES.adminContent },
    ],
  },
  {
    title: 'Campaigns',
    items: [
      { label: 'Generator', path: '/generator', icon: QrCode2Icon, allowedRoles: INTERNAL_ROUTE_ROLES.generator },
      { label: 'Link History', path: '/history', icon: HistoryIcon, allowedRoles: INTERNAL_ROUTE_ROLES.generator },
    ],
  },
  {
    title: 'Reporting',
    items: [
      { label: 'VOC Scoreboard', path: '/admin/voc-scoreboard', icon: LeaderboardIcon, allowedRoles: INTERNAL_ROUTE_ROLES.reporting },
      { label: 'Get Care Analytics', path: '/admin/get-care', icon: VolunteerActivismIcon, allowedRoles: INTERNAL_ROUTE_ROLES.reporting },
      { label: 'AAR Reporting', path: '/admin/aars-reporting', icon: ListAltIcon, allowedRoles: INTERNAL_ROUTE_ROLES.staff },
      { label: 'Scan Analytics', path: '/insights', icon: InsightsIcon, allowedRoles: INTERNAL_ROUTE_ROLES.reporting },
    ],
  },
  {
    title: 'Administration',
    items: [
      { label: 'VOC Monthly Import', path: '/admin/voc-monthly-import', icon: UploadFileIcon, allowedRoles: INTERNAL_ROUTE_ROLES.adminOnly },
      { label: 'Road Home LIVE Import', path: '/admin/road-home-live-import', icon: UploadFileIcon, allowedRoles: INTERNAL_ROUTE_ROLES.adminOnly },
      { label: 'Data Stewardship', path: '/admin/data-stewardship', icon: FactCheckIcon, allowedRoles: INTERNAL_ROUTE_ROLES.adminOnly },
      { label: 'Scan Logs (Raw)', path: '/analytics', icon: AutoGraphIcon, allowedRoles: INTERNAL_ROUTE_ROLES.adminOnly },
    ],
  },
];

export const alumNavSections = [
  {
    title: 'ALUM',
    items: [
      {
        label: 'Dashboard',
        path: '/me/alum',
        icon: AccountCircleIcon,
        allowedRoles: INTERNAL_ROUTE_ROLES.alum,
        matchers: ['/me/alum'],
      },
      {
        label: 'Submit AAR',
        path: '/me/alum/aars/new',
        icon: ListAltIcon,
        allowedRoles: INTERNAL_ROUTE_ROLES.alum,
        matchers: ['/me/alum/aars/new'],
      },
      {
        label: 'Create QR',
        path: '/me/alum/qr/new',
        icon: QrCode2Icon,
        allowedRoles: INTERNAL_ROUTE_ROLES.alum,
        matchers: ['/me/alum/qr', '/me/alum/qr/new'],
      },
      {
        label: 'Request Support',
        path: '/me/alum/support/new',
        icon: SupportAgentIcon,
        allowedRoles: INTERNAL_ROUTE_ROLES.alum,
        matchers: ['/me/alum/support/new'],
      },
    ],
  },
];

function getNavSectionsForRole(role) {
  return normalizeRole(role) === 'alum' ? alumNavSections : adminNavSections;
}

function isNavItemVisible(item, role, visibility = {}) {
  if (item.path === '/admin/data-stewardship') {
    return visibility.showDataStewardship !== false;
  }

  if (item.path === '/admin/alum') {
    return normalizeRole(role) === 'admin' || visibility.showAlumCommandCenter === true;
  }

  return true;
}

export function getVisibleAdminNavSections(role, visibility = {}) {
  return adminNavSections
    .map((section) => ({
      ...section,
      items: section.items.filter(
        (item) => hasRequiredRole(role, item.allowedRoles) && isNavItemVisible(item, role, visibility)
      ),
    }))
    .filter((section) => section.items.length > 0);
}

export function getVisibleShellNavSections(role, visibility = {}) {
  return getNavSectionsForRole(role)
    .map((section) => ({
      ...section,
      items: section.items.filter(
        (item) => hasRequiredRole(role, item.allowedRoles) && isNavItemVisible(item, role, visibility)
      ),
    }))
    .filter((section) => section.items.length > 0);
}

export function isNavItemActive(pathname, item) {
  if (item.matchers?.some((pattern) => matchPath({ path: pattern, end: true }, pathname))) {
    return true;
  }

  if (item.path === '/') return pathname === '/';
  return pathname === item.path;
}

export function getCurrentNavItem(pathname, role) {
  for (const section of getNavSectionsForRole(role)) {
    const match = section.items.find((item) => isNavItemActive(pathname, item));
    if (match) return match;
  }

  return null;
}
